import { useState, useEffect } from "react";
import { Box, Typography, Grid, Container } from "@mui/material";

// Reusable StatsCard component
const StatsCard = ({ targetNumber, suffix, label, duration = 2000 }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let startTime;
    let animationFrame;

    const animate = (currentTime) => {
      if (!startTime) startTime = currentTime;
      const progress = Math.min((currentTime - startTime) / duration, 1);

      // Easing function for smooth animation
      const easeOutQuart = 1 - Math.pow(1 - progress, 4);
      const currentCount = Math.floor(easeOutQuart * targetNumber);

      setCount(currentCount);

      if (progress < 1) {
        animationFrame = requestAnimationFrame(animate);
      }
    };

    animationFrame = requestAnimationFrame(animate);

    return () => {
      if (animationFrame) cancelAnimationFrame(animationFrame);
    };
  }, [targetNumber, duration]);

  return (
    <Box textAlign="center" sx={{ px: { xs: 2, sm: 0 } }}>
      <Typography
        variant="h2"
        fontWeight="bold"
        sx={{
          color: "#22c55e", // Tailwind's green-500
          mb: 1,
          fontSize: { xs: "2.5rem", sm: "3rem", md: "3.75rem" },
        }}
      >
        {count}
        {suffix}
      </Typography>
      <Typography
        variant="h6"
        sx={{
          color: "#1f2937", // Tailwind's gray-800
          fontWeight: 500,
          fontSize: { xs: "1rem", sm: "1.25rem" },
          lineHeight: 1.4,
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default function ImpactMetrics() {
  return (
    <Box
      sx={{
        bgcolor: "#fafafa", // Tailwind's gray-50
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: { xs: 2, sm: 3, md: 4 },
      }}
    >
      <Container maxWidth="lg">
        {/* Header */}
        <Box textAlign="center" mb={{ xs: 4, md: 6 }}>
          <Typography
            variant="h3"
            fontWeight="bold"
            sx={{
              color: "#111827", // Tailwind's gray-900
              mb: 2,
              fontSize: { xs: "1.8rem", sm: "2.5rem", md: "3rem" },
            }}
          >
            Impact Metrics
          </Typography>
        </Box>

        {/* Stats Grid */}
        <Grid container spacing={{ xs: 4, md: 6 }}>
          <Grid item xs={12} md={4}>
            <StatsCard
              targetNumber={50}
              suffix="K+"
              label="Community Members"
              duration={2500}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <StatsCard
              targetNumber={247}
              suffix="+"
              label="Partnerships & Collaborations"
              duration={2000}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <StatsCard
              targetNumber={38}
              suffix="+"
              label="MOUs Signed"
              duration={1500}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
